const en = {
  title: 'Orders',
  subtitle: 'Manage supplier orders',
  partsReport: '📊 Parts Report',
  createOrder: '+ Create Order',
  createOrderPlain: 'Create Order',
  statTotal: 'Total',
  statPending: 'Pending',
  statOrdered: 'Ordered',
  statDelivered: 'Delivered',
  statPartial: 'Partial',
  statCompleted: 'Completed',
  searchingLabel: 'Searching:',
  searchingHint: '(order number, notes, creator, part names)',
  allSuppliers: 'All Suppliers',
  allStatus: 'All Status',
  clearButton: 'Clear',
  emptyTitle: 'No Orders Yet',
  emptyMessage: 'Create your first order',
  colOrder: 'Order',
  colItems: 'Items',
  backorderCount: '⚠️ {{count}} backorder',
  view: 'View',
  moveToOrdered: '→ Ordered',
  receive: 'Receive',
  receiveMore: 'More',
  orderNumberLabel: 'Order Number (Optional)',
  orderNumberPlaceholder: 'e.g., PO-2024-001 (auto-generated if empty)',
  orderNotesLabel: 'Order Notes',
  orderNotesPlaceholderGeneral: 'General order notes...',
  addItemsLabel: 'Add Items ({{count}})',
  searchPartPlaceholder: 'Search part by name, color, SKU...',
  noPartsFound: 'No parts found',
  qty: 'Qty',
  addItemButton: '+ Add Item',
  itemNotesPlaceholder:
    'Item notes (e.g., color preference, size, special request...)',
  itemNotesPlaceholderShort: 'Item notes...',
  part: 'Part',
  subtotal: 'Subtotal',
  totalColon: 'Total:',
  receiveDeliveryTitle: 'Receive Delivery - {{order}}',
  ordered: 'Ordered',
  receiving: 'Receiving',
  notesPlaceholderShort: 'notes...',
  doneCount: '{{count}} done',
  doneCheck: '✓ Done',
  moveToAnotherOrder: 'Move to another order',
  deliveryNotesPlaceholder: 'Delivery notes...',
  orderTitle: 'Order - {{order}}',
  orderNumberPlaceholderShort: 'Order number',
  delivered: 'Delivered',
  orderNotesPlaceholder: 'Order notes...',
  addPartPlaceholder: 'Add part...',
  addShort: '+ Add',
  moveItemTitle: 'Move Item to Another Order',
  orderedQty: 'Ordered: {{qty}}',
  quantityToMove: 'Quantity to Move',
  maxPlaceholder: 'Max: {{max}}',
  moveToOrderLabel: 'Move to Order',
  selectOrderOption: '— Select order —',
  moveItemButton: '↗ Move Item',
  cancelOrderTitle: 'Cancel Order',
  cancelOrderMessage: 'Cancel order "{{order}}"?',
  stockLabel: 'Stock:',
  noSku: 'No SKU',
  status: {
    draft: 'Draft',
    pending: 'Pending',
    ordered: 'Ordered',
    delivered: 'Delivered',
    partial: 'Partial',
    cancelled: 'Cancelled',
    backorder: 'Backorder',
    completed: 'Completed',
    nla: 'NLA',
    closed: 'Closed (rest not coming)',
  },
  completeOrder: '✓ Complete',
  completeOrderTitle: 'Mark as completed (remaining quantity will not be delivered)',
  confirmCompleteOrder:
    'Complete order "{{order}}"?\n\nAll quantities that have not arrived yet will be closed and removed from backorder.',
  alertCompleteFailed: 'Failed to complete order: {{error}}',
  nlaBadge: 'NLA',
  // Alerts / confirm messages
  alertAddOneItem: 'Please add at least one item',
  alertCreateFailed: 'Failed to create order: {{error}}',
  alertSelectPartAndQty: 'Please select a part and enter valid quantity',
  alertPartNotFound: 'Part not found',
  alertPartAlreadyAdded: 'This part is already added',
  alertLoadFailed: 'Failed to load order: {{error}}',
  alertOrderNumberEmpty: 'Order number cannot be empty',
  alertUpdateOrderNumberFailed: 'Failed to update order number: {{error}}',
  alertUpdateNotesFailed: 'Failed to update notes: {{error}}',
  alertSaveNotesFailed: 'Failed to save notes: {{error}}',
  alertUpdateItemStatusFailed: 'Failed to update item status: {{error}}',
  alertSelectTargetOrder:
    'Please select a target order and enter a valid quantity',
  alertCannotTransferMore: 'Cannot transfer more than the ordered quantity',
  alertTransferFailed: 'Failed to transfer item: {{error}}',
  alertGenericFailed: 'Failed: {{error}}',
  alertUpdateStatusFailed: 'Failed to update status: {{error}}',
  alertCancelOrderFailed: 'Failed to cancel order: {{error}}',
  alertSelectPartAndEnterQty: 'Please select a part and enter quantity',
  alertAddItemFailed: 'Failed to add item: {{error}}',
  confirmRemoveItem: 'Are you sure you want to remove this item?',
  alertDeleteItemFailed: 'Failed to delete item: {{error}}',
};

const de = {
  title: 'Bestellungen',
  subtitle: 'Lieferantenbestellungen verwalten',
  partsReport: '📊 Teilebericht',
  createOrder: '+ Bestellung erstellen',
  createOrderPlain: 'Bestellung erstellen',
  statTotal: 'Gesamt',
  statPending: 'Ausstehend',
  statOrdered: 'Bestellt',
  statDelivered: 'Geliefert',
  statPartial: 'Teilweise',
  statCompleted: 'Abgeschlossen',
  searchingLabel: 'Suche:',
  searchingHint: '(Bestellnummer, Notizen, Ersteller, Teilenamen)',
  allSuppliers: 'Alle Lieferanten',
  allStatus: 'Alle Status',
  clearButton: 'Zurücksetzen',
  emptyTitle: 'Noch keine Bestellungen',
  emptyMessage: 'Erstellen Sie Ihre erste Bestellung',
  colOrder: 'Bestellung',
  colItems: 'Positionen',
  backorderCount: '⚠️ {{count}} im Rückstand',
  view: 'Ansehen',
  moveToOrdered: '→ Bestellt',
  receive: 'Empfangen',
  receiveMore: 'Mehr',
  orderNumberLabel: 'Bestellnummer (Optional)',
  orderNumberPlaceholder: 'z. B. PO-2024-001 (wird automatisch generiert, wenn leer)',
  orderNotesLabel: 'Bestellnotizen',
  orderNotesPlaceholderGeneral: 'Allgemeine Bestellnotizen...',
  addItemsLabel: 'Positionen hinzufügen ({{count}})',
  searchPartPlaceholder: 'Teil nach Name, Farbe, SKU suchen...',
  noPartsFound: 'Keine Teile gefunden',
  qty: 'Menge',
  addItemButton: '+ Position hinzufügen',
  itemNotesPlaceholder:
    'Positionsnotizen (z. B. Farbwunsch, Größe, Sonderwunsch...)',
  itemNotesPlaceholderShort: 'Positionsnotizen...',
  part: 'Teil',
  subtotal: 'Zwischensumme',
  totalColon: 'Gesamt:',
  receiveDeliveryTitle: 'Lieferung empfangen - {{order}}',
  ordered: 'Bestellt',
  receiving: 'Eingang',
  notesPlaceholderShort: 'Notizen...',
  doneCount: '{{count}} erledigt',
  doneCheck: '✓ Erledigt',
  moveToAnotherOrder: 'Zu einer anderen Bestellung verschieben',
  deliveryNotesPlaceholder: 'Liefernotizen...',
  orderTitle: 'Bestellung - {{order}}',
  orderNumberPlaceholderShort: 'Bestellnummer',
  delivered: 'Geliefert',
  orderNotesPlaceholder: 'Bestellnotizen...',
  addPartPlaceholder: 'Teil hinzufügen...',
  addShort: '+ Hinzufügen',
  moveItemTitle: 'Position zu einer anderen Bestellung verschieben',
  orderedQty: 'Bestellt: {{qty}}',
  quantityToMove: 'Zu verschiebende Menge',
  maxPlaceholder: 'Max.: {{max}}',
  moveToOrderLabel: 'Zu Bestellung verschieben',
  selectOrderOption: '— Bestellung auswählen —',
  moveItemButton: '↗ Position verschieben',
  cancelOrderTitle: 'Bestellung stornieren',
  cancelOrderMessage: 'Bestellung "{{order}}" stornieren?',
  stockLabel: 'Bestand:',
  noSku: 'Keine SKU',
  status: {
    draft: 'Entwurf',
    pending: 'Ausstehend',
    ordered: 'Bestellt',
    delivered: 'Geliefert',
    partial: 'Teilweise',
    cancelled: 'Storniert',
    backorder: 'Rückstand',
    completed: 'Abgeschlossen',
    nla: 'NLA',
    closed: 'Geschlossen (Rest kommt nicht)',
  },
  completeOrder: '✓ Abschliessen',
  completeOrderTitle: 'Als abgeschlossen markieren (Restmenge wird nicht geliefert)',
  confirmCompleteOrder:
    'Bestellung "{{order}}" abschliessen?\n\nAlle noch nicht gelieferten Mengen werden geschlossen und aus dem Rückstand entfernt.',
  alertCompleteFailed: 'Bestellung konnte nicht abgeschlossen werden: {{error}}',
  nlaBadge: 'NLA',
  // Alerts / confirm messages
  alertAddOneItem: 'Bitte fügen Sie mindestens eine Position hinzu',
  alertCreateFailed: 'Bestellung konnte nicht erstellt werden: {{error}}',
  alertSelectPartAndQty: 'Bitte wählen Sie ein Teil und geben Sie eine gültige Menge ein',
  alertPartNotFound: 'Teil nicht gefunden',
  alertPartAlreadyAdded: 'Dieses Teil wurde bereits hinzugefügt',
  alertLoadFailed: 'Bestellung konnte nicht geladen werden: {{error}}',
  alertOrderNumberEmpty: 'Bestellnummer darf nicht leer sein',
  alertUpdateOrderNumberFailed: 'Bestellnummer konnte nicht aktualisiert werden: {{error}}',
  alertUpdateNotesFailed: 'Notizen konnten nicht aktualisiert werden: {{error}}',
  alertSaveNotesFailed: 'Notizen konnten nicht gespeichert werden: {{error}}',
  alertUpdateItemStatusFailed: 'Positionsstatus konnte nicht aktualisiert werden: {{error}}',
  alertSelectTargetOrder:
    'Bitte wählen Sie eine Zielbestellung und geben Sie eine gültige Menge ein',
  alertCannotTransferMore: 'Es kann nicht mehr als die bestellte Menge verschoben werden',
  alertTransferFailed: 'Position konnte nicht verschoben werden: {{error}}',
  alertGenericFailed: 'Fehlgeschlagen: {{error}}',
  alertUpdateStatusFailed: 'Status konnte nicht aktualisiert werden: {{error}}',
  alertCancelOrderFailed: 'Bestellung konnte nicht storniert werden: {{error}}',
  alertSelectPartAndEnterQty: 'Bitte wählen Sie ein Teil und geben Sie eine Menge ein',
  alertAddItemFailed: 'Position konnte nicht hinzugefügt werden: {{error}}',
  confirmRemoveItem: 'Möchten Sie diese Position wirklich entfernen?',
  alertDeleteItemFailed: 'Position konnte nicht gelöscht werden: {{error}}',
};

const orders = { en, de };
export default orders;
